__turbopack_context__.v({
  "CloseDialogButton": "session-expired-dialog-module__9-qkdq__CloseDialogButton",
  "DialogContent": "session-expired-dialog-module__9-qkdq__DialogContent",
});
